import Image, { StaticImageData } from "next/image"

interface Props {
    image: StaticImageData
}

const SectionHeader: React.FC<Props> = (props: Props) => {
    return <header className='my-5 mx-5 lg:mx-40'>
        <Image src={props.image} alt="Habacus logo" height={40} />
    </header>
}

export default SectionHeader;
